mutation TravelerApprovalRevoke($input: TravelerApprovalRevokeInput!) {
  travelerApprovalRevoke(input: $input) {
    revokedApprovalEntity
  }
}
